export enum ProviderTypeEnum {
  person = "Person",
  equipment = "Equipment",
  room = "Room",
}
